/**
 * Documents shown in the "Info, privacy, terms and conditions" dialog and page
 * (AB#49545). The order is the one fixed by the acceptance criteria; the
 * addresses live in `keys.XP_INFO_LINKS` and the labels in the `infoPage`
 * translation group (`<id>` and `<id>Description`).
 */
export const INFO_DOCUMENT_GROUPS = [
  {
    id: "company",
    documents: [{ id: "aboutUs", icon: "fa-building" }],
  },
  {
    id: "legal",
    documents: [
      { id: "privacyNotice", icon: "fa-shield-halved" },
      { id: "termsOfUse", icon: "fa-scale-balanced" },
      { id: "termsAndConditions", icon: "fa-file-signature" },
      { id: "cookies", icon: "fa-cookie-bite" },
    ],
  },
];

const parseUrl = (href) => {
  try {
    return new URL(href);
  } catch (_) {
    return null;
  }
};

export const isPdf = (href) => /\.pdf$/i.test(parseUrl(href)?.pathname ?? "");

// What the user sees as the destination: the site for a web page, the file
// name for a PDF (its storage host would mean nothing to them).
export const documentDestination = (href) => {
  const url = parseUrl(href);
  if (!url) return "";
  if (isPdf(href)) return url.pathname.split("/").pop();
  return url.hostname.replace(/^www\./, "");
};

// The rule of the page footer this replaces (AB#31367), unchanged: the
// release (the publish date in production) for everyone, plus the build
// (commit ID) for superadmins, joined by " - ". Either part may be missing.
export const VERSION_SEPARATOR = " - ";

export const versionParts = ({ release, build, isSuperAdmin } = {}) => {
  const parts = [];
  if (release) parts.push(release);
  if (isSuperAdmin && build) parts.push(build);
  return parts;
};

export const versionLabel = (options) =>
  versionParts(options).join(VERSION_SEPARATOR);

export const PRODUCT_NAME = "Copeland Equipment Manager";
